import React from "react";
import { Grid } from "@material-ui/core";
import { useQuery } from '@apollo/react-hooks';
import TileDefault from "../../Tiles/Default/TileDefault";
import { GET_CPM } from "../../../queries/indicators";
import PageError from '../../PageError';
import PageLoading from '../../PageLoading';
import { momentFormat } from "../../Utils/formatters";
import { moment } from "../../Utils/momentConfig";

let card = [];

export default function CPMIndicator(props) {
  var { publishers } = props;
  let { data: dataIndicatorsCPM, error: errorCPM, loading: loadingCPM } = useQuery(GET_CPM, {
    variables: { publishers: publishers },
  });


  if(dataIndicatorsCPM){
    const rowCPM = dataIndicatorsCPM.reportCPMByPublisher;
    card = [
      {
        product: "CPM",
        today: { value: rowCPM.todayCPM ? rowCPM.todayCPM.toFixed(2): 0 },
        week : rowCPM.sevenDaysByDaysCPM ? rowCPM.sevenDaysByDaysCPM.map(row => ({ quantity: row.value ? row.value.toFixed(2) : "0", 
        dateSubscribed: moment(row.date).add(1, 'days').format(momentFormat) })): [],
        yesterday: { value: rowCPM.yesterdayCPM ? rowCPM.yesterdayCPM.toFixed(2): 0 },
        weekly: { value: rowCPM.sevenDaysCPM ? rowCPM.sevenDaysCPM.toFixed(2): 0 },
        monthly: { value: rowCPM.monthCPM ? rowCPM.monthCPM.toFixed(2): 0 },
        color: "primary"
      }
    ];
  }

  
  return (
    <>
      {(loadingCPM) ? <Grid item xs={12}><PageLoading /></Grid> : 
      (errorCPM) ? <Grid item xs={12}><PageError /></Grid> :
        (
          <>
            {
              card.map(stat => (
                  <Grid item md={4} sm={6} xs={12} key={stat.product}>
                    <TileDefault {...stat} />
                  </Grid>
              ))
            }
          </>
        )
      }
    </>
  );
}